import { Loader2 } from 'lucide-react';
import { Skeleton } from '@/components/ui/misc';
import { cn } from '@/utils';

export function Spinner({ className }: { className?: string }): React.JSX.Element {
  return (
    <span role="status" aria-label="Loading" className="inline-flex">
      <Loader2 className={cn('h-5 w-5 animate-spin text-primary', className)} />
    </span>
  );
}

export function PageLoader(): React.JSX.Element {
  return (
    <div className="flex h-64 items-center justify-center" role="status" aria-label="Loading page">
      <Spinner className="h-8 w-8" />
    </div>
  );
}

export function KpiSkeletonRow({ count = 5 }: { count?: number }): React.JSX.Element {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5" role="status" aria-label="Loading metrics">
      {Array.from({ length: count }, (_, i) => (
        <Skeleton key={i} className="h-20 rounded-lg" />
      ))}
    </div>
  );
}
